import { $, findTarget } from '../utils/Utils';
import Event from '../utils/Event';

const clearInput = (() => {
  const config = {
    triggers: [...$('.js-clearInputTrigger')],
    triggerCN: 'js-clearInputTrigger',
    targetCN: 'js-clearInputTarget',
    parentCN: 'js-clearInputParent',
    hideCN: '-hide',
  };

  const hide = (trigger) => {
    trigger.classList.add(config.hideCN);
    // accessibility
    trigger.setAttribute('aria-hidden', 'true');
  };

  const show = (trigger) => {
    trigger.classList.remove(config.hideCN);
    // accessibility
    trigger.removeAttribute('aria-hidden');
  };

  const handleHide = (element) => {
    const trigger = findTarget({ element, parent: config.parentCN, target: config.triggerCN });
    hide(trigger);
  };

  const handleShow = (element) => {
    const trigger = findTarget({ element, parent: config.parentCN, target: config.triggerCN });
    show(trigger);
  };

  const handleClick = ({ e, trigger }) => {
    const target = findTarget({
      element: trigger,
      parent: config.parentCN,
      target: config.targetCN,
    });
    e.preventDefault();
    target.value = '';
    hide(trigger);
    // emit event
    Event.emit('clearInput');
  };

  const build = () => {
    config.triggers.forEach((trigger) => {
      trigger.addEventListener('click', e => handleClick({ e, trigger }));
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
    hide: handleHide,
    show: handleShow,
  };
})();

export default clearInput;
